// extracted by mini-css-extract-plugin
export var bodyCopy = "main-cta-module--bodyCopy--a9523";
export var dark = "main-cta-module--dark--820dd";
export var headline = "main-cta-module--headline--01066";
export var image = "main-cta-module--image--3f07a";
export var imageWrapper = "main-cta-module--imageWrapper--d1650";
export var mainCta = "main-cta-module--mainCta--e8d56";
export var textContent = "main-cta-module--textContent--ae664";